<template>
  <div class="carousel" :style="{...wrapStyle}"
       @click="handleClickEvent()"
       @mouseenter="handleEvent('hover')"
  >
    <div style="overflow: hidden;width: 100%;height: 100%;" v-show="!isMarquee">
      <div
        class="carousel-panel" :style="trackStyle" ref="container">
        <div v-if="!images.length">
          <div class="carousel-panel__image" :class="getCss('default')"/>
        </div>
        <template v-else>
          <div
            v-for="(image, index) in images"
            :key="index"
            :ref="'carousel-' + index"
            class="carousel-panel__image"
            :class="[isVertical ? 'carousel-panel__vertical' : 'carousel-panel__horizontal']"
            @click="clickHandler(image)"
          >
            <img
              v-if="image.src"
              :class="getCss(['cover','show-img'])"
              v-src="image.src"
              width="100%"
              height="100%"
              :alt="image.alt"
            />
            <div v-else class="carousel-panel__image" :class="getCss('default')"/>
          </div>
        </template>
      </div>
    </div>

    <!-- 左右按钮 -->
    <div
      :style="`--arrow-opacity: ${arrowOpacity};--arrow-bg-color: ${arrowBgColor};
      --arrow-width:${arrowWidth}; --arrow-height:${arrowHeight}`"
      v-show="hasArrowButton && !isMarquee"
    >
      <a
        href="javascript:;"
        :style="{...leftStyle,'--leftArrow':leftArrow}"
        :class="{
        [getCss('left')]:true,
        'carousel-arrow':true,
        [getCss('left-default-arrow')]:!this.styles.carousel.config.leftArrowImage,
        }"
        @click="add(-1)"
      >
        <i></i>
      </a>

      <a
        href="javascript:;"
        class="carousel-arrow"
        :style="{...rightStyle,'--rightArrow':rightArrow}"
        :class="{
          [getCss('right')] : true,
          'carousel-arrow':true,
          [getCss('right-default-arrow')]:!this.styles.carousel.config.rightArrowImage,
        }"
        @click="add(1)"
      >
        <i></i>
      </a>
    </div>
    <!-- 分页器 -->
    <ul
      v-show="styles.carousel.config.hasIndicatePoint && !isMarquee"
      class="carousel-pagination"
      :class="[isVertical ? 'carousel-pagination__vertical' : 'carousel-pagination__horizontal']"
      :style="indicatorPointStyle"
    >
      <li
        v-for="index in styles.carousel.images.length"
        :key="index"
        class="carousel-pagination__item"
        :style="itemStyle"
        :class="[index - 1 === currentIndex ? 'carousel-pagination__item--active' : '']"
        @click="dotsEvent(index-1)"
      />
    </ul>
    <!--容器-->
    <div class="c-carousel__content" v-if="!isMarquee">
      <div class="c-carousel__content_outer" :style="trackStyle">
        <template v-for=" (item, index) in images">
          <div :key="index" class="c-carousel__content-slot">
            <div class="c-carousel__content-slot-position">
              <slot :name="`${index}`"></slot>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ul id="mylspaomadeng" v-show="isMarquee" :class="getCss('ul-marquee')" ref="divMerquee">
      <li v-for="(item,index) in images" :key="index" :class="getCss('iconShow')">
        <img :style="{...imgStyle}" :src="item.src"/>
      </li>
    </ul>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CCarousel',
  mixins: [componentBaseMixin],
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cssPrefix: 'carousel-',
      classKeys: ['default', 'cover', 'fill'],
      arrowOpacity: 1,
      currentIndex: 0,
      trackStyle: {},
      needBackGround: true,
      // isMarquee: false,
    };
  },

  computed: {
    hasArrowButton() {
      return this.styles.carousel.config.hasArrowButton;
    },
    arrowBgColor() {
      return this.styles.carousel.config.leftArrowImage ? 'none' : 'rgba(31,45,61,0.2)';
    },
    leftArrow() {
      return `url('${this.styles.carousel.config.leftArrowImage || 'none'}')`;
    },
    rightArrow() {
      return `url('${this.styles.carousel.config.rightArrowImage || 'none'}')`;
    },
    arrowWidth() {
      return this.deviceMode === 'pc' && !this.$isInEditor ? '60px' : '0.6rem';
    },
    arrowHeight() {
      return this.deviceMode === 'pc' && !this.$isInEditor ? '80px' : '0.8rem';
    },
    defaultColor() {
      return this.styles.carousel.config.defaultColor || '#BAC5D9';
    },
    activeColor() {
      return this.styles.carousel.config.activeColor || '#E4EAF4';
    },
    indicatorPointStyle() {
      const { indicationPointPositionType = 1, indicationPointBorderRadius = '25px' } = this.styles.carousel.config;
      const px = parseInt(indicationPointBorderRadius.substring(0, indicationPointBorderRadius.length - 2), 10);
      const rem = parseFloat(px / 100, 3);
      console.log('indicationPointPositionType px = rem =', px, rem);
      let bottom = 0;
      if (this.deviceMode === 'pc' && !this.isInEditor) {
        // margin 加了 5px
        bottom = indicationPointPositionType === 1 ? '5px' : `-${px + 10}px`;
      } else {
        bottom = indicationPointPositionType === 1 ? '0.1rem' : `-${0.2 + rem}rem`;
      }
      return {
        '--default-color': this.defaultColor,
        '--active-color': this.activeColor,
        position: 'absolute',
        bottom,
        display: 'block',
      };
    },
    isVertical() {
      return this.styles.carousel.config.direction === 'vertical';
    },
    isMarquee() {
      return this.styles.carousel.config.isMarquee || false;
    },
    leftStyle() {
      // transformOrigin 设置选择的定点
      return this.isVertical
        ? {
          left: '50%',
          top: '0',
          transform: 'translateX(-50%) rotate(90deg)',
          transformOrigin: 'center',
        }
        : { top: '50%', transform: 'translateY(-50%)', left: '8px' };
    },
    rightStyle() {
      return this.isVertical
        ? {
          left: '50%',
          bottom: '0',
          transform: 'translateX(-50%) rotate(90deg)',
          transformOrigin: 'center',
        }
        : { top: '50%', transform: 'translateY(-50%)', right: '8px' };
    },
    imgStyle() {
      return {
        width: this.deviceMode === 'pc' ? `${parseInt(this.styles.carousel.config.width, 10) || 200}px` : `${parseInt(this.styles.carousel.config.width, 10) / 100 || 2}rem`,
        height: '100%',
      };
    },
    wrapStyle() {
      if (this.needBackGround) {
        return {
          ...this.styles.base,
          backgroundColor: '#a7badb',
          overflow: this.isMarquee ? 'hidden' : 'visible',
        };
      }
      return {
        ...this.styles.base,
        overflow: this.isMarquee ? 'hidden' : 'visible',
      };
    },
    itemStyle() {
      //  分页点的样式
      const { indicationPointBorderRadius = '' } = this.styles.carousel.config;
      console.log('indicationPointBorderRadius =', indicationPointBorderRadius);
      let size = {};
      if (this.deviceMode === 'pc' && !this.$isInEditor) {
        size = { width: indicationPointBorderRadius || '25px', height: indicationPointBorderRadius || '25px' };
      } else {
        let remUint = 0.25;
        if (indicationPointBorderRadius) {
          remUint = parseInt(
            indicationPointBorderRadius.substring(0, indicationPointBorderRadius.length - 2),
            10,
          ) / 100;
        }
        remUint = `${remUint > 0 ? remUint : 0.25}rem`;
        size = { width: remUint || '0.25rem', height: remUint || '0.25rem' };
      }
      return this.isVertical ? { display: 'block', ...size } : { display: 'inline-block', ...size };
    },
    images() {
      const images = JSON.parse(JSON.stringify(this.styles.carousel.images));
      if (images.length && !this.isMarquee) {
        images.push({ ...images[0] });
      }
      return images;
    },
    eventMap() {
      const result = {};
      this.events.forEach((item) => {
        // 打开链接
        if (item.action === 'redirectURL' && item.trigger === 'click') {
          if (item.data && item.data[0]) {
            result[item.data[0].index] = item.data[1] || {};
          }
        }
      });
      return result;
    },
    // rem 转 px的时候 实际乘数
    multiplier() {
      if (this.$isInEditor) {
        return 100;
      }
      const fontSize = this.rootFontSize;
      return fontSize ? parseFloat(fontSize.substring(0, fontSize.length - 2), 3) : 50;
    },
  },
  watch: {
    'styles.carousel.config.autoPlay': {
      handler(newVal) {
        this.updatePlay(newVal);
      },
      immediate: true,
    },
    'styles.carousel.config.autoplaySpeed': {
      handler(newVal) {
        this.setAutoplay(newVal);
      },
      immediate: true,
    },
    curSlot: {
      deep: true,
      handler(curSlot) {
        this.currentIndex = parseInt(curSlot[this.uid], 10) || 0;
        this.update(this.currentIndex);
      },
    },
  },
  mounted() {
    console.log('this.styles carousel config =', this.styles);
    if (this.images.length > 0) {
      this.needBackGround = false;
    }
    if (this.isMarquee) {
      this.startTimer();
    } else {
      this.setAutoplay(this.styles.carousel.config.autoplaySpeed || 1500);
      this.$nextTick(() => {
        Object.keys(this.$refs).forEach((key) => {
          if (key.startsWith('carousel-')) {
            this.reportExposeRaw
            && this.reportExposeRaw({
              ele: this.$refs[key][0],
              ceibaComponentId: `${this.id}`,
              ceibaComponentUid: this.uid,
              eventId: 1030,
              ext: JSON.stringify({
                sub_type: 'expose-carousel',
                data: {
                  carousel_index: key.split('-')[1],
                },
              }),
            });
          }
        });
      });
      this.listenArrowEvent();
    }
  },
  methods: {
    clickHandler(item) {
      const data = this.eventMap[item.index];
      if (data && data.link === 'current') {
        // 上报轮播点击
        this.reportCustomEvent({
          ceibaComponentId: `${this.id}`,
          ceibaComponentUid: this.uid,
          eventId: 1031,
          ext: JSON.stringify({
            sub_type: 'pick-carousel',
            data: {
              carousel_index: item.index,
            },
          }),
        });
        const pageData = {
          action: 'redirectURL',
          data: [data],
          id: item.index,
          name: '单击时',
          trigger: 'click',
          type: 'text',
        };
        this.$emit('defined-event-emitted', [pageData]);
      } else if (data && data.link === 'outer') {
        if (data.target === '_self') {
          window.location.href = data.page;
        } else {
          window.open(data.page);
        }
      }
    },
    tranRemToPx(unit) {
      // eslint-disable-next-line no-param-reassign
      unit = unit.toLowerCase();
      if (unit.indexOf('rem') > -1) {
        const value = parseFloat(unit.substring(0, unit.length - 3), 3);
        return value * this.multiplier;
      }
      if (unit.indexOf('px') > -1) {
        return parseFloat(unit.substring(0, unit.length - 2), 3);
      }
    },
    listenArrowEvent() {
      if (this.$isInEditor) return;
      if (this.deviceMode === 'pc') {
        // 冒泡事件类型触发
        this.$nextTick(() => {
          const { container } = this.$refs;
          container.addEventListener('mouseover', this.mouseoverFunc, true);
          // 冒泡事件类型触发;
          container.addEventListener('mouseout', this.mouseleaveFunc, true);
        });
      }
    },
    mouseoverFunc() {
      this.arrowOpacity = 1;
    },
    mouseleaveFunc() {
      this.arrowOpacity = 0;
    },
    dotsEvent(index) {
      const offset = index - this.currentIndex;
      this.currentIndex = index;
      this.update(offset);
    },
    add(offset) {
      const sidesLen = this.styles.carousel.images.length;
      let index = this.currentIndex + offset;
      while (index < 0) {
        index += sidesLen;
      }
      this.currentIndex = index === sidesLen ? 0 : index;
      this.update(offset);
    },
    update(offset) {
      const slidesLen = this.styles.carousel.images.length;
      let index = this.currentIndex;
      if (this.currentIndex === 0 && offset > 0) {
        index = slidesLen;
      }
      const width = this.tranRemToPx(this.styles.base.width);
      const height = this.tranRemToPx(this.styles.base.height);
      this.trackStyle = {
        transition: 'transform 400ms ease',
        transform: this.isVertical ? `translateY(-${index * height}px)` : `translateX(-${index * width}px)`,
      };
      if (this.currentIndex === 0 && offset < 0) {
        setTimeout(() => {
          this.trackStyle = {
            transition: 'none',
            transform: this.isVertical ? `translateY(-${slidesLen * height}px)` : `translateX(-${slidesLen * width}px)`,
          };
        }, 500);
      }
      if (index === slidesLen) {
        setTimeout(() => {
          this.trackStyle = {};
        }, 500);
      }
    },
    updatePlay(newVal) {
      if (!newVal && this.timer) {
        window.clearInterval(this.timer);
        return;
      }
      this.setAutoplay(this.styles.carousel.config.autoplaySpeed || 1500);
    },
    setAutoplay(interval) {
      if (!this.styles.carousel.config.autoPlay || this.$isInEditor) {
        return;
      }
      window.clearInterval(this.timer);
      if (interval) {
        this.timer = window.setInterval(() => {
          this.add(1);
        }, interval);
      }
    },
    clearTimer() {
      clearInterval(this.timer);
    },
    startTimer() {
      if (this.mylsTimer !== null) {
        clearInterval(this.mylsTimer);
      }
      const oUl = this.$refs.divMerquee;
      // console.log('oUl', oUl);
      if (oUl !== null) {
        let i;
        oUl.innerHTML += oUl.innerHTML;
        oUl.innerHTML += oUl.innerHTML;
        oUl.innerHTML += oUl.innerHTML;
        const lis = oUl.getElementsByTagName('li');
        // console.log('lis', lis);
        let lisTotalWidth = 0;
        let resetWidth = 0;
        for (i = 0; i < lis.length; i++) {
          lisTotalWidth += lis[i].offsetWidth;
        }
        for (i = 1; i <= lis.length / 4; i++) {
          resetWidth += lis[i].offsetWidth;
        }
        console.log('this.deviceMode.offsetWidth', lisTotalWidth, resetWidth);
        oUl.style.width = this.deviceMode === 'pc' ? `${lisTotalWidth}px` : `${lisTotalWidth * 16}px`;
        resetWidth = this.deviceMode === 'pc' ? resetWidth : resetWidth * 10;
        console.log('this.deviceMode.offsetWidth', lisTotalWidth, resetWidth);
        let left = 0;
        this.mylsTimer = setInterval(() => {
          left -= 1;
          if (left <= -resetWidth) {
            left = 0;
          }
          oUl.style.left = `${left}px`;
        }, this.styles.carousel.config.timeout || 20);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.c-carousel__content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.c-carousel__content_outer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.c-carousel__content-slot {
  // position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
}

.c-carousel__content-slot-position {
  position: absolute;
  width: 100%;
  height: 100%;
}

.carousel {
  //overflow: hidden;

  &-panel {
    width: 100%;
    height: 100%;
    white-space: nowrap;

    &__image {
      width: 100%;
      height: 100%;
    }

    &__vertical {
      display: block;
    }

    &__horizontal {
      display: inline-block;
    }
  }

  &-arrow {
    opacity: var(--arrow-opacity);
    position: absolute;
    width: var(--arrow-height);
    height: var(--arrow-height);
    z-index: 999;
    display: inline-block;
    border-radius: 50%;
    //background-color: rgba(31,45,61,0.2);
    background-color: var(--arrow-bg-color);
    transition: all 0.4s;
    outline: none;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  &-pagination {
    position: absolute;
    z-index: 999;
    font-size: 0;
    border-radius: 0.125rem;

    &__vertical {
      right: 0.1rem;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      flex-direction: row;
      display: flex;
    }

    &__horizontal {
      left: 50%;
      bottom: 0.1rem;
      transform: translateX(-50%);
      justify-content: center;
      flex-direction: row;
      display: flex;
    }

    &__item {
      margin: 5px;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 50%;
      background: var(--default-color);
      cursor: pointer;

      &--active {
        background: var(--active-color);
      }
    }
  }
}
</style>
<style lang="scss">
@import './carousel.scss';
</style>
